/**
 * Focus a MUI `select` TextField from its root element (DNKADM-0386 U1 — "Choose
 * another coach" returns the operator to the Staff chooser with that field focused).
 *
 * A `select` TextField's focusable element is its `role="combobox"` display node, not
 * the hidden native input `inputRef` would hand back, so the hosts keep a ref on the
 * TextField ROOT and this finds the chooser inside it. A missing root (the chooser is
 * not rendered — a `none`/round-robin dimension) is a no-op.
 */
export function focusPicker(root: HTMLElement | null): void {
  root?.querySelector<HTMLElement>('[role="combobox"]')?.focus();
}
